import styled from 'styled-components';
import { Modal } from 'reactstrap';

export const StyledTitle = styled.p`
  color: #33373d;
`;

export const StyledModal = styled(Modal)`
  max-width: 672px !important;
`;
